<template>
    <div>
        <b-modal
            title="Registrar profissão"
            no-close-on-backdrop
            size="md"
            centered
            hide-footer
            cancel-title="Cancelar"
            cancel-variant="danger"
            header-bg-variant="orange"
            header-text-variant="light"
            id="modalProfission"
        >
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <label class="input-group-text" id="profission-name">Profissão</label>
                </div>
                <input type="text" class="form-control" aria-describedby="profission-name" v-model="area">
            </div>
            <hr>
                <div class="d-flex justify-content-between">
                    <b-button variant="danger" @click="$bvModal.hide('modalProfission')">Cancelar</b-button>
                    <b-button variant="success" @click="registerProfission()">Salvar</b-button>
                </div>
        </b-modal>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import makeToast from '@/mixins/makeToast';

export default {
    mixins: [makeToast],
    data: {
        return: {
            area: ''
        }
    },

    computed: {
        ...mapState({
            dadosUsuario: (state) => state.dadosUsuario,
        }),
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapActions('shopkeeper', [
            'cathProfission',
            'createProfission'
        ]),

        getData() {
        this.$store.dispatch('startLoader');
        this.$store
            this.cathProfission(this.dadosUsuario.id)
            .then(() => {
                // this.table.records = resp.data;
            })
            .catch(() => {
                this.makeToast(
                    'Erro',
                    'Houve um erro ao trazer os dados, favor atualizar a página!',
                    'danger'
                );
                })
            .finally(() => {
                this.$store.dispatch('endLoader');
            });
        },

        registerProfission(){
            const data = {
                area: this.area,
                construp_user_id: this.dadosUsuario.id
            }

            if(!data.area) {
                this.makeToast(
                    'Erro',
                    'O campo profissão não pode estar vazio',
                    'danger'
                    );
                return;
            }

            this.$store.dispatch('startLoader');
            this.$store
                this.createProfission(data)
                .then(() => {

                })
                .catch(() => {
                    this.makeToast(
                        'Erro',
                        'Houve um erro ao registrar profissão, favor atualizar a página!',
                        'danger'
                    );
                    })
                .finally(() => {
                    this.$store.dispatch('endLoader');
                    this.area = '';
                    this.$bvModal.hide('modalProfission');
                    this.getData();
                });
        }
    }
}
</script>